import { render, staticRenderFns } from "./AnswerCol.vue?vue&type=template&id=33d0e6e6&scoped=true"
import script from "./AnswerCol.vue?vue&type=script&lang=js"
export * from "./AnswerCol.vue?vue&type=script&lang=js"
import style0 from "./AnswerCol.vue?vue&type=style&index=0&id=33d0e6e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0e6e6",
  null
  
)

export default component.exports